import _ from 'lodash';
import { OrderedMap, fromJS } from 'immutable';
import * as constants from './constants';
import { LOGOUT } from '../loginSystem/constants';
import { CREATE_PPI_DONE } from '../PpiContainer/constants';

export const createDefaultState = () =>
  fromJS({
    ingredients: OrderedMap(),
    isFetching: false,
    isFetched: false,
    fetchError: null,
    isGlobalFetching: false,
    isGlobalFetched: false,
    fetchGlobalError: null,
    isExcludedFetching: false,
    isExcludedFetched: false,
    fetchExcludedError: null,
    isExcluding: false,
    excludeError: null,
    isIncluding: false,
    includeError: null
    // marketIngredients: Map(),
  });

// Transform list of objects to object with the id as keys
const mergeIngredients = (state, isExcluded, payload) => {
  const ingredientsToMerge = _.isArray(payload) ? payload : [payload];
  return state
    .get('ingredients')
    .merge(
      ingredientsToMerge.reduce(
        (map, ingredient) =>
          map.set(ingredient.itemCode, fromJS({ ...ingredient, isExcluded })),
        OrderedMap()
      )
    );
};

function ppiCreated(state, payload) {
  const { itemCode, id } = payload;
  return state.get('ingredients').update(itemCode, ingredient => {
    const updatedPpiList = ingredient.get('ppiList').push(id);
    return ingredient.set('ppiList', updatedPpiList);
  });
}

function setIngredientsIsExcluded(state, itemCodes = [], isExcluded) {
  let ingredientState = state.get('ingredients');
  itemCodes.forEach(itemCode => {
    ingredientState = ingredientState.update(itemCode, ingredient =>
      ingredient.set('isExcluded', isExcluded)
    );
  });
  return ingredientState;
}

function markIngredientsAsExcluded(state, itemCodes) {
  return setIngredientsIsExcluded(state, itemCodes, true);
}

function markIngredientsAsIncluded(state, itemCodes) {
  return setIngredientsIsExcluded(state, itemCodes, false);
}

export default function reducer(
  state = createDefaultState(),
  { type, payload }
) {
  switch (type) {
    case LOGOUT:
      return createDefaultState();

    case constants.FETCH_INGREDIENT:
    case constants.FETCH_INGREDIENTS:
      return state.set('isFetching', true).set('fetchError', null);
    case constants.FETCH_INGREDIENT_DONE: {
      return state
        .set('ingredients', mergeIngredients(state, false, payload))
        .set('fetchError', null)
        .set('isFetching', false);
    }
    case constants.FETCH_INGREDIENTS_DONE: {
      return state
        .set('ingredients', mergeIngredients(state, false, payload))
        .set('fetchError', null)
        .set('isFetching', false);
      // .set('isFetched', true);
    }
    case constants.FETCH_INGREDIENT_FAIL:
    case constants.FETCH_INGREDIENTS_FAIL:
      return state.set('fetchError', fromJS(payload)).set('isFetching', false);

    case constants.FETCH_GLOBAL_INGREDIENTS:
      return state.set('isGlobalFetching', true).set('fetchGlobalError', null);
    case constants.FETCH_GLOBAL_INGREDIENTS_DONE:
      return state
        .set('ingredients', mergeIngredients(state, false, payload))
        .set('isGlobalFetching', false)
        .set('isGlobalFetched', true)
        .set('fetchGlobalError', null);
    case constants.FETCH_GLOBAL_INGREDIENTS_FAIL:
      return state
        .set('isGlobalFetching', false)
        .set('fetchGlobalError', fromJS(payload));

    case constants.FETCH_EXCLUDED_INGREDIENTS:
      return state
        .set('isExcludedFetching', true)
        .set('fetchExcludedError', null);
    case constants.FETCH_EXCLUDED_INGREDIENTS_DONE:
      return state
        .set('ingredients', mergeIngredients(state, true, payload))
        .set('isExcludedFetching', false)
        .set('isExcludedFetched', true)
        .set('fetchExcludedError', null);
    case constants.FETCH_EXCLUDED_INGREDIENTS_FAIL:
      return state
        .set('isExcludedFetching', false)
        .set('fetchExcludedError', fromJS(payload));

    case constants.EXCLUDE_INGREDIENTS:
      return state
        .set('isExcluding', true)
        .set('excludeError', null)
        .set('ingredients', markIngredientsAsExcluded(state, payload));
    case constants.EXCLUDE_INGREDIENTS_DONE:
      return state.set('isExcluding', false).set('excludeError', null);
    case constants.EXCLUDE_INGREDIENTS_FAIL:
      return state
        .set('isExcluding', false)
        .set('excludeError', fromJS(payload));

    case constants.INCLUDE_INGREDIENTS:
      return state
        .set('isIncluding', true)
        .set('includeError', null)
        .set('ingredients', markIngredientsAsIncluded(state, payload));
    case constants.INCLUDE_INGREDIENTS_DONE:
      return state.set('isIncluding', false).set('includeError', null);
    case constants.INCLUDE_INGREDIENTS_FAIL:
      return state
        .set('isIncluding', false)
        .set('includeError', fromJS(payload));

    case CREATE_PPI_DONE:
      return state.set('ingredients', ppiCreated(state, payload));

    // case constants.FETCH_MARKET_INGREDIENTS:
    //     return state.set('isFetching', true).set('fetchError', null);
    //   case constants.FETCH_MARKET_INGREDIENTS_DONE: {
    //     return state
    //       .set('marketIngredients', fromJS(payload))
    //       .set('fetchError', null)
    //       .set('isFetching', false);
    //   }
    //   case constants.FETCH_MARKET_INGREDIENTS_FAIL:
    //     return state.set('fetchError', fromJS(payload)).set('isFetching', false);

    default:
      return state;
  }
}
